import read from './read';
import write from './write';
export { read, write };
export default { read: read, write: write };
